import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const NoXpacks = ({ onImport }) => (
  <EmptyView>
    <span className="icon-no-projects" />
    <p>You have no xPacks</p>
    <p>
      Please{' '}
      <Button isLink data-test="import-xpack-button" onClick={onImport}>
        import
      </Button>{' '}
      xPack
    </p>
  </EmptyView>
);

NoXpacks.propTypes = {
  onImport: PropTypes.func,
};

export default NoXpacks;
